import { render, staticRenderFns } from "./OwnNumberForm.vue?vue&type=template&id=f390c768&scoped=true"
import script from "./OwnNumberForm.vue?vue&type=script&lang=js"
export * from "./OwnNumberForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f390c768",
  null
  
)

export default component.exports